<template>

  <div class="fixed inset-0 w-full h-full flex items-center justify-center bg-gray-100">
    <div class="bg-white rounded-lg shadow p-4">
      <div class="font-thin px-2 pb-4 text-xl">Digite o código de acesso</div>
      <div class="flex">
        <input
          ref="code_1"
          class="h-16 w-12 border mx-2 rounded-lg flex items-center text-center font-thin text-3xl"
          value=""
          maxlength="1"
          max="9"
          min="0"
          inputmode="decimal"
          v-model="codes[0]"
          @keyup="$refs.code_2.focus()"
          @focus="clearValue($refs.code_1,0)"
        />
        <input
          ref="code_2"
          v-model="codes[1]"
          @keyup="$refs.code_3.focus()"
          @focus="clearValue($refs.code_2,1)"
          class="h-16 w-12 border mx-2 rounded-lg flex items-center text-center font-thin text-3xl"
          value=""
          maxlength="1"
          max="9"
          min="0"
          inputmode="decimal"
        />
        <input
          ref="code_3"
          v-model="codes[2]"
          @keyup="$refs.code_4.focus()"
          @focus="clearValue($refs.code_3,2)"
          class="h-16 w-12 border mx-2 rounded-lg flex items-center text-center font-thin text-3xl"
          value=""
          maxlength="1"
          max="9"
          min="0"
          inputmode="decimal"
        />
        <input
          v-model="codes[3]"
          @keyup="login"
          @focus="clearValue($refs.code_4,3)"
          ref="code_4"
          class="h-16 w-12 border mx-2 rounded-lg flex items-center text-center font-thin text-3xl"
          maxlength="1"
          max="9"
          min="0"
          inputmode="decimal"
        />
      </div>
      <div>
        <jet-input-error
          :message="form.errors.codigo_acesso"
          class="mt-2 text-center"
        />

      </div>

    </div>
  </div>

</template>

<script>
import ButtonPrimary from '@/Components/ButtonPrimary';
import JetInputError from '@/Jetstream/InputError';
export default {
  components: { ButtonPrimary, JetInputError, },
  data() {
    return {
      form: this.$inertia.form({
        codigo_acesso: null
      }),
      codes: [
        null,
        null,
        null,
        null,
      ]
    }
  },
  methods: {
    clearValue(ref, index) {
      ref.value = null;
      console.log(index);
      this.codes[index] = null;
    },
    save() {
      this.form.post(this.route('entrevista-colaborador.dologin'));
    },
    login() {
      this.form.codigo_acesso = _.join(this.codes, '');
      this.form.post(this.route('entrevista-colaborador.dologin'));
    }
  }
}
</script>

  <style>
</style>
